export default __webpack_public_path__ + "static/media/190629_192557_DSCN3219.a168523c.JPG";